import { ProductPurchasesLookupResolveService } from './shared/services/product-purchases-lookup-resolve.service';
// import { JobseekerLookupResolveService } from './shared/services/jobseeker-lookup-resolve.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// import { JobseekersShellComponent } from './jobseekers-shell/jobseekers-shell.component';
// import { JobseekerListComponent } from './jobseeker-list/jobseeker-list.component';
// import { JobseekerViewEditComponent } from './jobseeker-view-edit/jobseeker-view-edit.component';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { ProductPurchasesShellComponent } from '@admin/product-purchases/product-purchases-shell/product-purchases-shell.component';
import { CvDatabaseProductRequestListComponent } from '@admin/product-purchases/cv-database-product-request-list/cv-database-product-request-list.component';
import { SliderBannerProductRequestListComponent } from '@admin/product-purchases/slider-banner-product-request-list/slider-banner-product-request-list.component';
import { CvBoxProductRequestListComponent } from './cv-box-product-request-list/cv-box-product-request-list.component';
import { BrandingProductRequestListComponent } from './branding-product-request-list/branding-product-request-list.component';
import { AuthGuard } from '../core/auth.guard';

const productPurchasesRoutes: Routes = [
  {
    path: 'product-purchases',
    component: ProductPurchasesShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: ProductPurchasesLookupResolveService,
    },
    children: [
      {
        path: '',
        redirectTo: 'cv-database-products',
        pathMatch: 'full',
      },
      {
        path: 'cv-database-products',
        component: CvDatabaseProductRequestListComponent,
      },
      {
        path: 'cv-box-products',
        component: CvBoxProductRequestListComponent,
      },
      {
        path: 'slider-banner-products',
        component: SliderBannerProductRequestListComponent,
      },
      {
        path: 'branding-products',
        component: BrandingProductRequestListComponent,
      },
      // {
      //     path: 'edit/:id',
      //     component: JobseekerViewEditComponent
      //     //TODO resolver
      // }
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(productPurchasesRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class ProductPurchasesRoutingModule {}
